// extracted by mini-css-extract-plugin
module.exports = {"saffron_sec":"SaffronSection_saffron_sec__Puttk","saffron_sec_desc":"SaffronSection_saffron_sec_desc__fTjcz"};